<template>
  <div class="container">
    <div class="app-container">
      <div style="display: flex; width: 90%">
        <!-- 内容部分 -->
        <div style="flex: 1; margin: 10px 20px" v-for="(item, index) in listRow" :key="index">
          <div style="background-color: #242f42; padding: 2px 10px">
            <span style="font-size: 20px; color: white">{{ item.name }}</span>
            <span @click="toAdd(item.notice_level)" style="float: right; color: white; cursor: pointer"><i class="el-icon-plus"></i> 添加</span>
            <span @click="toMore(item.path)" style="float: right; color: white; cursor: pointer; margin-right: 10px"><i class="el-icon-plus"></i> 更多</span>
          </div>
          <el-table v-loading="listLoading" :data="item.source" style="width: 100%" @row-click="rowFunc">
            <el-table-column v-if="index !== 2" prop="game_name" label="游戏" align="center" width="100" />
            <el-table-column prop="notice_title" label="标题" width="200" align="center" :show-overflow-tooltip="true">
              <template scope="scope">
                <span :style="{ color: chooseColor(scope.row), fontWeight: scope.row.is_read === 0 ? 'bold' : 'normal' }"> {{ scope.row.notice_title }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="上传时间" align="center" />
          </el-table>
        </div>
        <!-- 添加弹窗 -->
        <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
        <!-- 查看弹窗 -->
        <Dialog
          ref="checkdialog"
          @submitForm="closeCheckDialog"
          @closeDialog="closeCheckDialog"
          :dialogTitle="'查看'"
          :dialogVisible="dialogCheckVisible"
          :dialogModel="checkDialogModel"
          dialogWidth="700px"
        ></Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '../../components/common/Dialog';
import { getHomeBulletinBoard, getBulletinBoardSelect, bulletinBoardPost, readBulletinBoard, getSuggestionAdminSelect } from '@/api/first_page.js';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      listRow: [
        { name: '重要通知', source: [], path: 'morePage.affice', notice_level: 1 },
        // { name: '特定通知', source: [], path: 'morePage.activity', notice_level: 2 },
        { name: '部门资料', source: [], path: 'morePage.notify', notice_level: 3 },
      ],
      listLoading: false,
      dialogVisible: false,
      dialogTitle: '新增',
      level: 1,
      gameOptions: [],
      adminOptions: [],
      dialogCheckVisible: false,
    };
  },
  computed: {
    dialogModel() {
      return [
        this.level !== 3 && {
          type: 'el-select',
          label: '游戏',
          prop: 'game_id',
          options: this.gameOptions,
        },
        {
          type: 'el-input',
          label: '标题',
          prop: 'notice_title',
        },
        {
          type: 'el-input-textarea',
          label: this.level === 3 ? '在线链接' : '通知内容',
          prop: 'content',
          rows: 12,
        },
        (this.level === 1 || this.level === 2) && {
          type: 'el-upload-image-list',
          label: '上传图片',
          prop: 'notice_images',
        },
        this.level === 2 && {
          type: 'el-tree-select',
          label: '被通知人',
          prop: 'to_admin_id',
          options: this.adminOptions,
          isMultiple: true,
        },
      ];
    },
    checkDialogModel() {
      return [
        {
          type: 'el-input-textarea',
          label: this.level === 3 ? '在线链接' : '通知内容',
          prop: 'content',
          rows: 12,
        },
        {
          type: 'el-image-swiper',
          label: '图片',
          prop: 'notice_images',
          showPagination: true,
        },
      ];
    },
  },
  mounted() {
    this.getPage();
    this.getSelectList();
    this.getSuggestionAdminSelect();
  },
  methods: {
    // 获取筛选项列表
    async getSelectList() {
      const { data } = await getBulletinBoardSelect();
      if (data.code !== 200) return;
      this.gameOptions = data.data.game;
    },
    async getSuggestionAdminSelect() {
      const { data } = await getSuggestionAdminSelect();
      // 映射
      const obj = { hangzhou: '杭州', shandong: '山东', normal: '普通客服', vip: 'VIP客服' };
      const treeData = Object.keys(data.data).map((m) => {
        // 获取vip节点下面的子结构
        const vipKeys = Object.keys(data.data[m]['vip']);
        return {
          id: m,
          label: obj[m],
          children: [
            {
              id: `${m}-normal`,
              label: obj['normal'],
              children: data.data[m]['normal'].map((o) => ({ id: o.id, label: o.name })),
            },
            {
              id: `${m}-vip`,
              label: obj['vip'],
              children: vipKeys.map((n, i) => ({ id: `${m}-vip-${n}`, label: `VIP客服${i + 1}组`, children: data.data[m]['vip'][n].map((o) => ({ id: o.id, label: o.name })) })),
            },
          ],
        };
      });
      this.adminOptions = treeData;
    },
    async getPage() {
      this.listLoading = true;
      const { data } = await getHomeBulletinBoard();
      if (data.code !== 200) return;
      this.listRow[0]['source'] = data.data['important_notice'];
      this.listRow[1]['source'] = data.data['department_data'];
      // this.listRow[2]['source'] = data.data['department_data'];
      this.listLoading = false;
    },
    rowFunc(row) {
      this.readBulletinBoardPut(row.id);
      // 重要通知 & 特定通知
      if (row.notice_level === 1 || row.notice_level === 2) {
        if (row.notice_source === 1) {
          this.openCheckDialog(row);
        } else if (row.notice_source === 2 && row.content != '') {
          window.open(row.content, '_blank');
        } else if (row.notice_source === 2 && row.content == '') {
          this.$message({ message: '文件为空，仅显示标题', type: 'warning' });
        }
        return;
      }
      // 部门资料
      if (row.notice_source === 1) {
        window.open(row.content, '_blank');
      } else if (row.notice_source === 2 && row.content != '') {
        window.open(row.content, '_blank');
      } else if (row.notice_source === 2 && row.content == '') {
        this.$message({ message: '文件为空，仅显示标题', type: 'warning' });
      }
    },
    toMore(name) {
      this.$router.push({ name: name });
    },
    toAdd(level) {
      this.dialogVisible = true;
      this.level = level;
    },
    // 点击确定
    async dialogSure(form) {
      form.notice_images && (form.notice_images = form.notice_images.map((m) => m.url));
      const obj = Object.assign({ notice_level: this.level, notice_source: 1 }, form);
      const { data } = await bulletinBoardPost(obj);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getPage();
    },
    // 点击关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 点击关闭查看弹窗
    closeCheckDialog() {
      this.dialogCheckVisible = false;
      this.$refs.checkdialog.resetForm();
    },
    // 点击打开查看弹窗
    openCheckDialog(row) {
      this.dialogCheckVisible = true;
      this.$refs.checkdialog.resetForm();
      this.$refs.checkdialog.editForm(row);
    },
    // 已读消息
    async readBulletinBoardPut(id) {
      await readBulletinBoard(id);
      this.getPage();
    },
    // 选择颜色
    chooseColor(row) {
      if (row.is_top === 1) {
        return 'red';
      } else if (row.is_read === 0) {
        return 'black';
      }
      return '#606266';
    },
  },
};
</script>


<style scoped>
div.el-transfer .el-transfer-panel {
  width: 400px;
}
.container {
  padding: 30px;
  background-color: #f0f0f0;
  border: 0px;
}

.el-row {
  margin-bottom: 20px;
}
.grid-content {
  display: flex;
  align-items: center;
  height: 100px;
}

.grid-cont-right {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
}

.grid-num {
  font-size: 30px;
  font-weight: bold;
}

.grid-con-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.grid-con-1 .grid-con-icon {
  background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
  color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
  background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
  color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
  background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
  color: rgb(242, 94, 67);
}

.user-info {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
}

.user-avator {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.user-info-cont {
  padding-left: 50px;
  flex: 1;
  font-size: 14px;
  color: #999;
}

.user-info-cont div:first-child {
  font-size: 30px;
  color: #222;
}

.user-info-list {
  font-size: 14px;
  color: #999;
  line-height: 25px;
}

.user-info-list span {
  margin-left: 70px;
}

.mgb20 {
  margin-bottom: 20px;
}

.todo-item {
  font-size: 14px;
}

.todo-item-del {
  text-decoration: line-through;
  color: #999;
}

.schart {
  width: 100%;
  height: 300px;
}
</style>
